import { Component } from '@angular/core';
import { NavController, NavParams, IonicPage } from 'ionic-angular';
import { DataProvider } from '../../providers/data/data';
import { SpotPage } from "../spot/spot";

/**
 * Generated class for the SpotsListPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-spots-list',
  templateUrl: 'spots-list.html',
})
export class SpotsListPage {


  id;
  urlCode;
  lang;
  exhibition;
  spots:any;

  constructor(public navCtrl: NavController, public navParams: NavParams, private _DataProvider: DataProvider) {
    
  this.urlCode = this.navParams.get('muzeum');
  this.id = this._DataProvider.getLocalStorage('exhibitionID');
  console.log(this.urlCode,this.id);
  this.lang = this._DataProvider.getLocalStorage('lang');
  }




  ionViewDidLoad() {
    //  this.exhibition = this._DataProvider.getExhibitionByID(this.id);
    console.log('this.id',this.id);
    console.log(this._DataProvider.ExhibitionsService);
     if(this.id){
  
   console.log('this.id',this.id);
    //  this._DataProvider.getExhibitionByID(this.id)
    //var res = this._DataProvider.getExhibitionByIDFB(this.id);
      
      
    //    console.log('res: --- ---- ',res);
        let self = this;
     // this._DataProvider.getExhibitionByLang(this._DataProvider.Muzeum.id,this.lang)
     this._DataProvider.getSpotsByExhibitionIDFB(this.id)
     .subscribe(res => {
       console.log(res);
       this.spots = res;
  
   console.log(this.spots);

         });
  
  
  
          
        }//end of if
  
    }
  

}



// WEBPACK FOOTER //
// ./src/pages/spots-list/spots-list.ts